<template>
  <div id="tab1" class="tab-item identite-produit">
    <div class="col-100 indentite-produit-top">
      <div class="col-33 identite-produit-top_left">
        <dl>
          <div v-if="product.type">
            <dt>Type</dt>
            <dd>{{ product.type | capitalize }}</dd>
          </div>
          <div v-if="fonctions">
            <dt>Fonction(s)</dt>
            <dd>{{ fonctions }}</dd>
          </div>
          <div v-if="product.amm">
            <dt v-if="isProductMO">Numéro Anses</dt>
            <dt v-else>Numéro AMM</dt>
            <dd>{{ product.amm }}</dd>
          </div>
          <div v-if="product.category">
            <dt>Type commercial</dt>
            <dd>
              {{ product.category.name }}
              <template v-if="Array.isArray(product.category.references)">
                <template
                  v-for="(reference, index) in product.category.references"
                >
                  <template v-if="index === 0"
                    >(Spécialités similaires:
                  </template>
                  <router-link
                    :to="{
                      name: 'productIdentity',
                      params: { id: String(reference.id) },
                    }"
                    :key="index"
                  >
                    <template
                      v-if="index !== product.category.references.length - 1"
                    >
                      {{ reference.name }},
                    </template>
                    <template v-else>{{ reference.name }})</template>
                  </router-link>
                </template>
              </template>
              <template v-else>
                (Produit de référence:
                <router-link
                  :to="{
                    name: 'productIdentity',
                    params: { id: String(product.category.references.id) },
                  }"
                >
                  {{ product.category.references.name }})
                </router-link>
              </template>
            </dd>
          </div>
          <div v-else>
            <dt>Type commercial</dt>
            <dd>
              {{ product.type_commercial }}
            </dd>
          </div>
          <div v-if="product.firm">
            <dt>Firme détentrice</dt>
            <dd>{{ product.firm }}</dd>
          </div>
          <div v-if="product.first_authorisation_date">
            <dt class="red bold">Date de première autorisation en France</dt>
            <dd>{{ product.first_authorisation_date }}</dd>
          </div>
          <div v-if="product.removal_date">
            <dt class="red bold">Date de retrait AMM</dt>
            <dd>{{ product.removal_date }}</dd>
          </div>
          <div v-if="product.end_marketing_date">
            <dt class="red bold">
              Date de fin de commercialisation réglementaire
            </dt>
            <dd>{{ product.end_marketing_date }}</dd>
          </div>
          <div v-if="product.end_use_date">
            <dt class="red bold">Date de fin d'utilisation règlementaire</dt>
            <dd>{{ product.end_use_date }}</dd>
          </div>
        </dl>
      </div>
      <div class="col-66 identite-produit-top_right">
        <dl v-if="product.formulation">
          <dt>Formulation</dt>
          <dd>
            {{ product.formulation.code }} ({{ product.formulation.name }})
          </dd>
        </dl>
        <h4 class="orange font-bold">Composition</h4>
        <div class="table">
          <div class="row table_head">
            <div class="cell" v-if="isProductMO">Nom du macro-organisme</div>
            <div class="cell" v-else>Substance active</div>

            <div class="cell" v-if="!isProductMO">
              <span v-if="product.type == 'Biocide'">Type de biocide</span
              ><span v-if="product.type == 'Phytopharmaceutique'"
                >Code RAC</span
              >
            </div>
            <div class="cell" v-if="!isProductMO">Concentration</div>
          </div>
          <div
            class="row"
            v-for="relation in product.productactivesubstance_set"
            :key="relation.active_substance.id"
          >
            <div class="cell" col-title="Substance active">
              <router-link
                :to="{
                  name: 'substanceIdentity',
                  params: { id: String(relation.active_substance.id) },
                }"
              >
                {{ relation.active_substance.name }}
              </router-link>
            </div>
            <div
              v-if="!isProductMO && isProductPhyto"
              class="cell"
              col-title="Code RAC"
            >
              <span v-if="relation.active_substance.code_rac[0]">
                {{ relation.active_substance.code_rac[0].rac_type }} :
                {{ relation.active_substance.code_rac[0].code }}
              </span>
              <span v-else> - </span>
            </div>
            <div
              v-if="!isProductMO && !isProductPhyto"
              class="cell"
              col-title="Code RAC"
            >
              <div
                v-for="subtype in relation.active_substance.subtypes"
                :key="subtype.name"
              >
                <p v-if="subtype.name.includes('Biocide')">
                  {{ subtype.name }}
                </p>
                <!-- <span v-if="subtype.length > 1">/</span> -->
                <p v-if="subtype.name == ''">-</p>
              </div>
            </div>

            <div v-if="!isProductMO" class="cell" col-title="Concentration">
              <span v-if="relation.concentration">
                {{ round(relation.concentration) }} {{ relation.unit }}
              </span>
              <span v-else class="text-center"> - </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="product.comment || product.cepp"
      class="identite-produit-bottom mt-5"
    >
      <div class="identite-produit-bottom_item">
        <dl>
          <dt>Commentaire</dt>
          <dd v-html="product.comment"></dd>
          <dd v-if="product.cepp">
            <div v-for="(cepp, ceppKey) in product.lst_cepp" :key="ceppKey">
              <div v-for="(item, itemKey, index) in cepp" :key="itemKey" class="inline-block">
                <div v-if="item.montant_variable">
                  <span v-html="transformStringCEPP(item.montant_variable, item.unite_cepp, ceppKey, cepp.url)"></span>
                </div>
                <div v-else>
                  <span v-if="item.montant || item.unite_cepp">
                  <span v-if="index !== 0"> ; </span>
                  Cité dans la <a :href="cepp.url" target="_blank" class="text-gray-900 font-bold">fiche CEPP n°{{ ceppKey }}</a> (montant : {{item.montant}} certificat(s) / {{ item.unite_cepp }})
                </span>
                </div>
              </div>
            </div> 
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductIdentity',

  props: {
    product: Object
  },

  computed: {
    fonctions () {
      return this.product.natures ? this.product.natures.join(', ') : ''
    },

    isProductMO () {
      return this.product.type === 'Macro-organisme'
    },

    isProductPhyto () {
      return this.product.type === 'Phytopharmaceutique'
    },
    

  },
  methods: {
    round(num) {
      let str = num.replace(/(\d+\.?\d*)/g,(p)=>{return parseFloat(p)});
      return str;
    },
    transformStringCEPP(str, unite, cepp, ceppUrl) {
      const ceppString = `Cité dans la <a href="${ceppUrl}" target="_blank" class="text-gray-900 font-bold">fiche CEPP n° ${cepp} </a>`
      const transformedStringToArray = str.split("|");
      if (transformedStringToArray.length === 1) {
        return ceppString + '('+ str.toLowerCase() + ' / ' + unite + ')';
      }
      else {
        const removeFirstElement = transformedStringToArray.slice(1).join("|");
        const newArrayWithoutFirstElement = removeFirstElement.split("|");
      
      const transformedfirstElementToString = JSON.stringify(transformedStringToArray[0]);
      const firstElement = JSON.parse(transformedfirstElementToString).toLowerCase();
      let listString = "<ul class='listCepp'>";
        newArrayWithoutFirstElement.forEach((item) => {
        let lastElementOfThisArray =  newArrayWithoutFirstElement[newArrayWithoutFirstElement.length - 1];
        if (item === lastElementOfThisArray) {
          listString += `<li>${item} / ${unite})</li>`;
        } else {
          listString += `<li>${item} / ${unite}</li>`;
        }
      });
      listString += "</ul>";
      return ceppString + ' (' + firstElement + listString ;
      }
    }
  },
};
</script>
<style>

.element-cepp:first-child{
  margin-right: 5px;
}

.listCepp{
  list-style: disc;
  margin-left: 45px;
}

</style>
